/* eslint-disable max-len */
module.exports = {
  // ================ CONTACTS ================
  contacts: {
    text1: "Contacts",
    text2: "Limited liability company",
    firmName: "«Geocontrol-NN»",
    firmAddress: "Address: 603014, Russia, Nizhny Novgorod city, Sormovskoe highway, 24/6, room 3",
    firmINN: "TIN 5250059408",
    firmKPP: "PPC 525001001",
    firmOGRN: "OGRN 1145250000125",
    firmPhone: "Phone +7 (831) 410-24-11",
    markerlabel: "Geocontrol-NN<br>Sormovskoe highway, 24/6",
    ourworkers: [
      {
        position: "Director",
        name: "Pavel",
        phone: "+79040498124"
      },
      {
        position: "Chief engineer",
        name: "Maxim",
        phone: "+79108876927"
      },
      {
        position: "NDT-Laboratory Header",
        name: "Vasily",
        phone: "+79006254541"
      }
    ]
  }
};
/* eslint-enable max-len */
